import { AppProfileRegisterRepositoryImpl } from "../data/AppProfileImpl";
import { IAppProfileRepository } from "../domain/repositories/IAppProfileRepository";
import { AppProfileUseCase } from "../domain/useCases/AppProfileUseCase";
import { AppProfileViewModel } from "../presentation/viewModel/AppProfileViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AppProfileInjection extends InjectionModule {
  private static readonly appProfileRepositoryToken = Symbol(
    "IAppProfileRepository",
  );
  private static readonly appProfileUseCaseToken = Symbol("AppProfileUseCase");
  private static readonly appProfileViewModelToken = Symbol(
    "AppProfileViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.appProfileRepositoryToken,
      useClass: AppProfileRegisterRepositoryImpl,
    },
    {
      scope: "otherRepo",
      token: this.appProfileUseCaseToken,
      useClass: AppProfileUseCase,
    },
    {
      scope: "viewModel",
      token: this.appProfileViewModelToken,
      useClass: AppProfileViewModel,
    },
  ];

  static getRepo(): IAppProfileRepository {
    return this.resolve(this.appProfileRepositoryToken);
  }

  static getUseCase(): AppProfileUseCase {
    return this.resolve(this.appProfileUseCaseToken);
  }
}
